import React from "react";
import { motion, useReducedMotion } from "framer-motion";
type RevealProps = {
  children: React.ReactNode;
  className?: string;
  delay?: number;
};

/** Rises and fades content in once as it scrolls into view. */
export function Reveal({
  children,
  className,
  delay = 0
}: RevealProps) {
  const reduce = useReducedMotion();
  return <motion.div className={className} initial={reduce ? false : {
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }}
  // "some" triggers as soon as any part is visible — a fractional amount can never be
  // reached by blocks taller than the screen, which would leave them invisible
  viewport={{
    once: true,
    amount: "some",
    margin: "0px 0px -10% 0px"
  }} transition={{
    duration: 0.3,
    ease: [0.23, 1, 0.32, 1],
    delay
  }} data-id="element-367" data-mp="3gfxmmvg57kjp">
      {children}
    </motion.div>;
}